import React, { useState } from "react";
import { Alert, Box, Snackbar, Typography } from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ChevronRight";
import { useNavigate } from "react-router";
import BackArrowIcon from "@assets/icons/backArrowIcon";
import AddUserForm from "./AddUserForm";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "@store/store";
import { clearLoadingState } from "@store/addUserSlice";
const AddUser: React.FC = () => {
  const [editUserDetails, setEditUserDetails] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const { addUserError, updateUserError } = useSelector(
    (state: any) => state.addUser
  );
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleAlertClose = () => {
    dispatch(clearLoadingState());
    setShowLoader(false);
  };

  return (
    <Box className="px-4 md:px-8 pt-6" sx={{ height: "calc(100vh - 120px)" }}>
      <Box className="flex pb-4 justify-between ">
        <Box className="flex items-center">
          <Box
            className="flex items-center cursor-pointer"
            onClick={handleBackClick}
          >
            <Typography>
              <BackArrowIcon />
            </Typography>
            <Typography
              component="div"
              sx={{ color: "#318FE0", paddingLeft: "0.5rem" }}
            >
              User Management
            </Typography>
          </Box>
          <ArrowRightIcon />
          <Typography component="div" sx={{ mr: "auto" }}>
            {editUserDetails ? "Edit User" : "Add User"}
          </Typography>
        </Box>
      </Box>
      <Box>
        <AddUserForm
          setShowLoader={setShowLoader}
          showLoader={showLoader}
          setEditUserDetails={setEditUserDetails}
          editUserDetails={editUserDetails}
        />
      </Box>
      <Snackbar
        className="!pt-[8rem] md:!pt-14"
        open={!!(addUserError ?? updateUserError)}
        autoHideDuration={3000}
        onClose={handleAlertClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert variant="filled" severity="error">
          {addUserError ?? updateUserError}
        </Alert>
      </Snackbar>
    </Box>
  );
};
export default AddUser;
